import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.7 3.577v.544a4.63 4.63 0 0 1 3.9 4.574v1.018c0 1.383.473 2.727 1.335 3.809l.454.566a.73.73 0 0 1-.57 1.189H4.632a.732.732 0 0 1-.571-1.189l.454-.566A6.1 6.1 0 0 0 5.85 9.713V8.695a4.63 4.63 0 0 1 3.9-4.574v-.544a.975.975 0 1 1 1.95 0m-1.218 1.95a3.17 3.17 0 0 0-3.17 3.168v1.018c0 1.46-.422 2.882-1.208 4.101h9.244a7.57 7.57 0 0 1-1.21-4.101V8.695a3.17 3.17 0 0 0-3.169-3.168zm2.193 10.725c0 .49-.204 1.014-.57 1.38a2 2 0 0 1-1.38.57 1.95 1.95 0 0 1-1.38-.57 2 2 0 0 1-.57-1.38z"
    }, null, -1)
  ]))]))
}
export default { render: render }